import type { ReactNode } from 'react';
import { Card, CardBody, Col, Row } from 'react-bootstrap';

type StatusCardTemplateProps = {
  icon: ReactNode;
  iconBackgroundColor: string;
  primaryText: string;
  secondaryText: string;
  dataTest?: string;
};

export default function StatusCardTemplate({
  icon,
  iconBackgroundColor,
  primaryText,
  secondaryText,
  dataTest,
}: StatusCardTemplateProps) {
  return (
    <Card data-test={dataTest}>
      <CardBody>
        <Row className="align-items-center">
          <Col
            xs={1}
            className="d-flex align-items-center justify-content-center"
          >
            <div
              className={`bg-${iconBackgroundColor} w-100 d-flex align-items-center justify-content-center rounded`}
              style={{ aspectRatio: '1 / 1' }}
            >
              {icon}
            </div>
          </Col>
          <Col xs={11} className="d-flex flex-column justify-content-center">
            <h6 className="mb-1">{primaryText}</h6>
            <p
              className="mb-0 text-gray-500"
              style={{ whiteSpace: 'pre-line' }}
            >
              {secondaryText}
            </p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
